import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { ColumnFlexBox } from '@/shared/ui/layout';
import InputField from '@/shared/ui/input-field';

export const CardContainer = styled(ColumnFlexBox)(({ theme }) => ({
  gap: theme.spacing(4),
  padding: theme.spacing(6),
  borderRadius: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(4),
  },
}));

export const InfoItem = styled(ColumnFlexBox)(({ theme }) => ({
  width: '100%',
  gap: theme.spacing(6),
}));

export const HeaderText = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 500,
  lineHeight: '120%',
  color: theme.customColors.black,
}));

export const InputContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gridTemplateRows: 'auto auto',
  columnGap: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'minmax(0, 1fr)',
    rowGap: theme.spacing(4),
  },
}));

export const InputColumn = styled(ColumnFlexBox)(({ theme }) => ({
  gap: theme.spacing(4),
}));

export const UserInfoButton = styled(Button)(({ theme }) => ({
  alignSelf: 'flex-end',
  width: '50%',
  padding: '14px',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '120%',
  minWidth: 180,
  borderRadius: theme.spacing(2),
  color: theme.palette.background.paper,
  backgroundColor: theme.customColors.primary100,
  '&:hover': {
    backgroundColor: theme.customColors.purple80,
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

export const CustomInput = styled(InputField)(({ theme }) => ({
  margin: 0,
  '& .MuiOutlinedInput-input': { padding: theme.spacing(2.5) },
  '& .MuiInputLabel-root': { color: theme.customColors.black50, fontSize: 18, top: '-5px' },
  '& .MuiInputBase-root': { borderRadius: 6 },
}));
